module.exports = __webpack_public_path__ + "static/media/chxadWxU.59214db0.svg";